import { useRequest } from "@/shared/composables/useRequest.ts";
import { HttpClientService } from "@/shared/services/http_client/HttpClientService.ts";
import { InstitutionRepository } from "@/app/institution/repositories/InstitutionRepository";
import { InstitutionModel } from "@/app/institution/models/InstitutionModel";

export function getAllInstitutionsController() {
  const repository: InstitutionRepository = new InstitutionRepository(new HttpClientService());

  return useRequest<InstitutionModel[]>({
    fn: async () => await repository.getAllInstitutions(),
  });
}
